export enum CanalTemplateEnum {
  WHATSAPP = 'WHATSAPP',
  SMS = 'SMS',
}
